module.exports = __webpack_public_path__ + "img/kill.fa016c97.svg";